import gql from 'graphql-tag';

export const sessionReportScoreFieldsFragment = gql`
  fragment AdminSessionReportScoreFields on SessionReportScore {
    score
    maxScore
  }
`;